
import { Observable } from "rxjs";
import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ParameterService } from "./parameter.service";
import { throwError } from 'rxjs';





import { DashboardLayout, Margin, WidgetConfig, WidgetPosition } from '../interfaces/dashboard.config.interface';


@Injectable()
export class DashboardConfigManager {
    paramFinder = /\$(.*?)\$/g;
    private configUrl = "configs/";
    private configParamName = "configfile";
    private defaultConfigFile = "DashboardDefaultConfig.json"
    config: any;
    hasConfig: boolean = false;
    params = new Map<string, string>();
    systemData: any[] = [];
    hasSystemData: boolean;
    //constructor
    public constructor(private http: HttpClient, private parameterService: ParameterService) {

    }

    //get configuration for dashboard main grid 
    public getDashboardLayout(): DashboardLayout {

        let dashlayout: any = this.config["DashboardLayout"];
        let margins: any = dashlayout["Margins"];
        let logger: any = dashlayout["Logging"];
        let layout: DashboardLayout = {
            rows: dashlayout["Rows"],
            cols: dashlayout["Columns"],
            logger: {
                loggerName: (logger != null && typeof logger != "undefined") ? logger["LoggerName"] : "",
                turnOnInfoTrace: (logger != null && typeof logger != "undefined") ? typeof (logger["TurnOnInfoTrace"]) === "boolean" ? logger["TurnOnInfoTrace"] : (logger["TurnOnInfoTrace"] === "true") : true,
                turnOnErrorTrace: (logger != null && typeof logger != "undefined") ? typeof (logger["TurnOnErrorTrace"]) === "boolean" ? logger["TurnOnErrorTrace"] : (logger["TurnOnErrorTrace"] === "true") : true,
                turnOnWarningTrace: (logger != null && typeof logger != "undefined") ? typeof (logger["TurnOnWarningTrace"]) === "boolean" ? logger["TurnOnWarningTrace"] : (logger["TurnOnWarningTrace"] === "true") : true
            },
            Margins: {
                left: margins["Left"],
                top: margins["Top"],
                bottom: margins["Bottom"],
                right: margins["Right"]
            },
            backgroundColor: dashlayout["BackgroundColor"]
        };

        return layout;
    }

    private getConfigFileURI(): string {
        try {
            let uri = this.configUrl;
            let str: any = this.parameterService.getParameter(this.configParamName);
            let configParam = str != undefined && str != null && str != "" ? str.indexOf('.json') >= 0 ? undefined : str : undefined;
            if (configParam) {
                var config = this.parameterService.getParameter(configParam)
                if (config != undefined) {
                    this.config = JSON.parse(config);
                    this.hasConfig = true;
                    uri = null;
                } else { uri += this.defaultConfigFile }
            }
            else if (str != undefined && str != null && str != "" && str.indexOf('.json') >= 0) {
                uri += str;
            } else {
                uri += this.defaultConfigFile;
            }
            return uri;
        }
        catch (error) {
            console.log(error);
        }

    }

    public readConfig(): Promise<void> {
        try {
            let service = this;
            let uri = this.getConfigFileURI();
            let promise: Promise<void> = new Promise<void>(function (resolve) {
                if (uri != null) {
                    service.http.get(uri)
                        .subscribe((res: any) => {
                            try {
                                if (res.status < 200 || res.status >= 300) {
                                    throw new Error("Bad response status: " + res.status);
                                }
                                service.config = res;
                                service.hasConfig = true;
                                resolve();
                            } catch (error) {
                                console.log(error);
                            }
                        }, service.handleError);
                } else if (service && service.config) { resolve(); } else { console.log("Error while reading config JSON"); }
            });
            return promise;
        }
        catch (error) {
            console.log(error)
        }
    }

    public getWidgets(): WidgetConfig[] {
        let widgets = this.config["widgets"];
        let widgetConfigs: WidgetConfig[] = [];
        for (let i = 0; i < widgets.length; i++) {
            let widget = widgets[i];
            let layout = widget["layout"];
            //Get Http requests of the widgets
            //this.getHttpRequests(widget["dataProvider"]);
            let dp = widget["dataProvider"];

            widgetConfigs.push({
                name: widget["Name"],
                chartType: widget["ChartType"],
                layout: {
                    startRow: layout["startRow"],
                    startColumn: layout["startColumn"],
                    rowspan: layout["rowspan"],
                    columnSpan: layout["columnSpan"]
                },
                dataProvider: {
                    name: dp["name"],
                    privateConfig: dp["privateConfig"]
                },
                config: widget["Config"],
                style: widget["style"]
            });
        }

        return widgetConfigs;
    }

    public getBaseUrl(): string {
        let url = undefined;
        if (this.hasConfig && this.config) {
            url = this.config["baseURI"];
        }
        return url;
    }

    private getHttpRequests(dataProvider: any) {
        if (!dataProvider) {
            return; //TODO: error
        }

        let httpReqs: any = [];
        let reqs = dataProvider["httpReqs"];
        if (reqs) {
            //Get Data Provider level config
            let dataPvderConfig = this.getDataProviderConfig(dataProvider["name"]);

            let dpHttpConfig: any = undefined;
            if (dataPvderConfig) dpHttpConfig = dataPvderConfig["httpConfig"]

            let dpHttpReqs = undefined;
            if (dpHttpConfig) dpHttpReqs = dpHttpConfig["httpReqs"];

            //Get Widget level config
            let widgetConfig = dataProvider["httpConfig"];
            let listKeys = Object.keys(reqs);
            for (let reqCnt = 0; reqCnt < listKeys.length; reqCnt++) {
                //get provider's request
                let dpHttpReq = undefined;
                if (dpHttpReqs) dpHttpReq = dpHttpReqs[listKeys[reqCnt]];

                let httpReq = this.getHttpRequest(reqs[listKeys[reqCnt]], widgetConfig, dpHttpReq, dataPvderConfig);
            }
        }

    }

    private getDataProviderConfig(dpName: string): any {
        let dataProviders = this.config["dataProviders"];
        if (dataProviders) {
            let dpLevelConfig = dataProviders[dpName];
            if (dpLevelConfig) {
                return dpLevelConfig;
            }
        }

        return undefined;
    }

    private getHttpRequest(reqConfig: any, widgetConfig: any, reqDpConfig: any, dpConfig: any): any {
        var httpReq: any = {};

        //Merge with widget config
        let temp1config = this.mergeConfig(reqConfig, widgetConfig);

        //Merge with dpConfig
        let temp2config = this.mergeConfig(temp1config, reqDpConfig);

        //Merge with dpConfig
        let finalConfig = this.mergeConfig(temp2config, dpConfig);

        //Check for base URI
        if (!finalConfig.baseURI) finalConfig.baseURI = this.config["baseURI"];

        //evaluate uri
        finalConfig.uri = this.replaceParams(finalConfig.uri, finalConfig.params);

        return finalConfig;
    }

    private mergeConfig(config1: any, config2: any): any {
        var dest = {};
        //baseURI (rule:replace)
        this.setProp(dest, config1, config2, "baseURI");

        //type (rule:replace)

        //path (rule:replace)
        this.setProp(dest, config1, config2, "uri");

        //queryParams

        //headers

        //body

        //params
        this.mergeSetProp(dest, config1, config2, "params");

        return dest;
    }

    private setProp(dest: any, config1: any, config2: any, propName: string) {
        if (dest[propName])
            return; //already set

        if (config1[propName])
            dest[propName] = config1[propName];
        else if (config2[propName])
            dest[propName] = config2[propName];
    }

    private mergeSetProp(dest: any, config1: any, config2: any, propName: string) {
        let retObj: any = dest[propName];
        if (!retObj)
            retObj = {};

        if (config1[propName]) {
            for (var attrname in config1[propName]) {
                if (!retObj[attrname])
                    retObj[attrname] = config1[attrname]
            }
        }

        if (config2[propName]) {
            for (var attrname in config2[propName]) {
                if (!retObj[attrname])
                    retObj[attrname] = config2[attrname]
            }
        }

        dest[propName] = retObj;
    }

    private getBaseConfigURI(reqConfig: any, widgetConfig: any, dpConfig: any): string {
        var retStr = null;
        if (reqConfig) retStr = reqConfig["baseURI"];
        if (!retStr) {
            if (widgetConfig)
                retStr = widgetConfig["baseURI"];
        }

        if (!retStr) {
            if (dpConfig)
                retStr = dpConfig["baseURI"];
        }

        if (!retStr) {
            retStr = this.config["baseURI"];
        }
        return retStr;
    }

    private replaceParams(url: string, params: any): string {
        let retStr = url.substr(0);

        let match;
        while (match = this.paramFinder.exec(url)) {
            let value: any = this.parameterService.getParameter(match[1]);

            if (!value && params) {
                value = params[match[1]];
            }

            if (value) {
                retStr = retStr.replace("$" + match[1] + "$", value);
            }
        }

        return retStr;
    }

    private extractData(res: Response) {

    }

    private handleError(error: any): Observable<any> {
        //alert(" handleError recd! ");
        // In a real world app, we might send the error to remote logging infrastructure
        let errMsg: any = error.message || "Server error";
        console.error(errMsg); // log to console instead
        return throwError(errMsg);
    }

    //Configuration substitution
    replaceQueryParams(props, arr) {
        props = props == undefined ? this.config : props;
        if (typeof (props) != "string" || arr == undefined) {
            for (let propName in props) {
                if (typeof (props[propName]) != undefined && typeof (props[propName]) != "object") {
                    if (props[propName].toString().startsWith('$') && props[propName].toString().endsWith('$')) {
                        this.params.set(propName, props[propName].slice(1, props[propName].length - 1));
                        let propertyValue = this.parameterService.getParameter(this.params.get(propName));
                        if (propertyValue != undefined) {
                            props[propName] = (propertyValue.startsWith('{') || propertyValue.startsWith('[')) && (propertyValue.endsWith('}') || propertyValue.endsWith(']')) ? JSON.parse(propertyValue) : propertyValue;
                        } else {
                            console.log("unable to find value of " + props[propName].slice(1, props[propName].length - 1) + " from url params");
                            props[propName] = undefined;
                        }
                    }
                }
                else if (props[propName] != undefined && props[propName].length != undefined && props[propName].length > 0) {
                    for (let i in props[propName]) {
                        this.replaceQueryParams(props[propName][i], props[propName])
                    }
                }
                else { this.replaceQueryParams(props[propName], undefined) };
            }
        }
        else {
            let propName = props.slice(1, props.length - 1);
            if (props.toString().startsWith('$') && props.toString().endsWith('$')) {
                this.params.set(propName, propName);
                let propertyValue = this.parameterService.getParameter(this.params.get(propName));
                if (propertyValue != undefined) {
                    var i = arr.indexOf(props);
                    arr[i] = (propertyValue.startsWith('{') || propertyValue.startsWith('[')) && (propertyValue.endsWith('}') || propertyValue.endsWith(']')) ? JSON.parse(propertyValue) : propertyValue;
                }
            }
        }
    }
}